import React from 'react'
import Style from './Privacy.module.css'

const Privacy = () => {
    return (
        <>
            <div className='Navbar__Height'></div>
            <div className={Style.Privacy__Page__Section}>
                <div className={Style.Header__Section}>
                    <div className='container'>
                        <h1 className={Style.Page__Title}>Privacy Policy</h1>
                        <h5 className={Style.Sub__Title}>
                            At Fyntiq LLC (“Fyntiq”), we value your trust and respect your privacy. 
                            Fyntiq exists to support entrepreneurs by offering a fast and easy way 
                            to manage your finances while exceeding your privacy expectations.
                        </h5>
                    </div>
                </div>
                <div className={Style.Content__Section}>
                    <div className='container'>

                        <h4>Scope</h4>
                        <p>
                            This Privacy Policy applies to <a href="https://fyntiq.com" target="_blank" rel="noreferrer">www.fyntiq.com</a> 
                            and its subdomains (the “Site”), and our mobile apps, all of which are 
                            owned and operated by Fyntiq LLC. It does not apply to any third-party 
                            websites, which have their own policies. 
                        </p>
                        <p>
                            When we say “Fyntiq,” we mean our company, including the Site and any 
                            mobile apps. When we say “Services,” we mean the various financial 
                            products, tools, and services we make available, including payments, 
                            payroll, accounting, invoicing, and other small business–related services.
                        </p>
                        <p>
                            “Personal Information” means information about an identifiable individual. 
                            This policy describes how we collect, protect, use, retain, and disclose 
                            Personal Information and your rights relating to these activities. 
                            We may also compile certain aggregate, de-identified data about our users.
                        </p>

                        <h4>Privacy Principles</h4>
                        <p>
                            Fyntiq’s Privacy Policy is based on the following 10 fair information principles:
                        </p>
                        <ol>
                            <li>Accountability</li>
                            <li>Identifying purposes</li>
                            <li>Consent</li>
                            <li>Limiting collection</li>
                            <li>Limiting use, disclosure, and retention</li>
                            <li>Accuracy</li>
                            <li>Safeguards</li>
                            <li>Openness</li>
                            <li>Individual access</li>
                            <li>Challenging compliance</li>
                        </ol>

                        <h4>Accountability and Challenging Compliance</h4>
                        <p>
                            Fyntiq has appointed a Privacy Officer responsible for overseeing compliance 
                            with this Privacy Policy. If you have any questions about our privacy 
                            practices, you can contact us at:
                        </p>
                        <ul>
                            <li>Fyntiq LLC</li>
                            <li>Privacy Officer</li>
                            <li>16192 Coastal Highway</li>
                            <li>Lewes, Delaware 19958</li>
                            <li>United States of America</li>
                        </ul>
                        <p>
                            Email: <a href="mailto:privacy@fyntiq.com"><strong>privacy@fyntiq.com</strong></a>
                        </p>

                        <h4>Identifying Purposes</h4>
                        <p>
                            Fyntiq collects, uses, and discloses Personal Information for purposes 
                            directly related to providing and improving our Services, supporting your 
                            account, and complying with legal obligations. For example:
                        </p>
                        <ul>
                            <li>To provide our Services, including payments, payroll, invoicing, and accounting tools.</li>
                            <li>To communicate with you about updates, educational resources, and product improvements.</li>
                            <li>To provide customer support.</li>
                            <li>To comply with legal obligations such as anti-money laundering laws, court orders, or investigations.</li>
                            <li>In connection with business transactions such as a merger, acquisition, or restructuring.</li>
                        </ul>

                        <h4>Consent</h4>
                        <p>
                            We rely on your consent to collect, use, and disclose Personal Information. 
                            When you provide information about others (e.g., employees or customers), 
                            you are responsible for ensuring that you have obtained the necessary consent.
                        </p>

                        <h4>Closing Your Account</h4>
                        <p>
                            You may withdraw your consent by closing your Fyntiq account. Please 
                            follow the full closure process, including confirmation steps, to ensure 
                            your account is fully closed.
                        </p>

                        <h4>Email and Communications</h4>
                        <p>
                            You can opt out of promotional emails by using the unsubscribe link or 
                            account settings. We may still send non-promotional emails necessary to 
                            operate your account (e.g., system notifications, major updates, or legal notices).
                        </p>

                        <h4>Collection Limitations</h4>
                        <p>
                            Fyntiq only collects the information necessary to provide Services. 
                            We may use trusted third-party services (such as Plaid) to connect to 
                            your financial accounts securely. Fyntiq is not directed to children 
                            and does not knowingly collect information from anyone under 18 years of age.
                        </p>

                        <h4>Use, Disclosure & Retention</h4>
                        <p>
                            We will use and retain Personal Information only as long as necessary 
                            to provide Services and comply with legal requirements. If you close 
                            your account, we will delete your Personal Information within 90 days, 
                            unless required by law to retain it longer.
                        </p>

                        <h4>Accuracy</h4>
                        <p>
                            You are responsible for ensuring that the Personal Information you 
                            provide is accurate and current. You may update your information at 
                            any time by logging into your account or contacting us directly.
                        </p>

                        <h4>Safeguards</h4>
                        <p>
                            We use administrative, technical, and physical safeguards (such as 
                            encryption, firewalls, and secure hosting) to protect Personal Information. 
                            For more details, visit our <a href="https://fyntiq.com/security" target="_blank" rel="noreferrer">Security</a> page.
                        </p>
                        <p>
                            Contact: <a href="mailto:security@fyntiq.com"><strong>security@fyntiq.com</strong></a>
                        </p>

                        <h4>Openness</h4>
                        <p>
                            This Privacy Policy is available publicly at <a href="https://fyntiq.com/privacy" target="_blank" rel="noreferrer">https://fyntiq.com/privacy</a>. 
                            Please contact our Privacy Officer with any questions.
                        </p>

                        <h4>Individual Access</h4>
                        <p>
                            You have the right to access and correct your Personal Information. 
                            You may export or update your data directly through your account or 
                            by contacting us.
                        </p>

                        <h4>Additional Details</h4>
                        <h5>Public Content and Social Media</h5>
                        <p>
                            Information you post in public forums or testimonials may be visible 
                            to others. You can request removal by contacting <a href="mailto:privacy@fyntiq.com">privacy@fyntiq.com</a>.
                        </p>

                        <h5>Service Providers</h5>
                        <p>
                            We may share information with third-party service providers who assist 
                            us in hosting, processing payments, or providing other business services. 
                            These providers may process data in the U.S. or other jurisdictions and 
                            are bound by confidentiality obligations.
                        </p>

                        <h5>Cookies & Analytics</h5>
                        <p>
                            We use cookies and analytics tools (e.g., Google Analytics) to understand 
                            site usage and improve our Services. You may disable cookies in your browser, 
                            but doing so may limit functionality.
                        </p>

                        <h4>Changes to This Policy</h4>
                        <p>
                            We may update this Privacy Policy from time to time. Material changes 
                            will be communicated by email or through our Site before they take effect. 
                            Please review this page periodically for the latest version.
                        </p>

                        <h4>Governing Law</h4>
                        <p>
                            This Privacy Policy shall be governed by the laws of the State of Delaware 
                            and applicable U.S. federal law.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Privacy